<template>
    <Head :title="'Historique expédition N°'+ travel.reference" />

    <TravelLayout :currency="currency">
        <div class="bg-white shadow-lg sm:rounded-md border border-gray-200 mb-4">
            <header class="px-5 py-1 bg-sky text-white">
                <h2 class="font-semibold">L'historique de l'expédition</h2>
            </header>
            <div class="sm:rounded-md p-6">
                <ol class="relative border-l border-gray-200 dark:border-gray-700">
                    <li class="mb-10 ml-6" v-for="(history, index) in travel.historical" :key="index">
                        <div class="absolute w-3 h-3 rounded-full mt-1.5 -left-1.5 border-2"
                            :class="history.pass ? 'bg-'+history.status_color+'-500 border-'+history.status_color+'-700' : 'bg-white border-gray-300'"
                        ></div>
                        <time class="mb-1 text-sm font-normal leading-none capitalize"
                            :class="history.pass ? 'text-'+history.status_color+'-400' : 'text-gray-400'"
                        >
                            {{ history.pass ? history.date : 'Bientôt' }}
                        </time>
                        <h3 class="text-lg font-semibold"
                            :class="history.pass ? 'text-'+history.status_color+'-500' : 'text-gray-400'"
                        >
                            {{ history.name }}
                        </h3>
                    </li>
                </ol>
            </div>
        </div>
    </TravelLayout>
</template>

<script>
    import { defineComponent } from 'vue'
    import { Head } from '@inertiajs/inertia-vue3';
    import TravelLayout from '@/Layouts/TravelLayout.vue'

    export default defineComponent({
        components: {
            Head,
            TravelLayout
        },

        props: {
            travel: Object,
            currency: Object
        },
    })
</script>
